import React from "react";
import { HOME_THEME } from "../../features/home/theme";
import { translations, LanguageCode } from "../../utils/translations";

interface ProcessSectionProps {
  lang?: LanguageCode;
}

const ProcessSection: React.FC<ProcessSectionProps> = ({ lang = "en" }) => {
  const content = translations[lang].automatePage;

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>{content.processHeading}</h2>
        <p style={styles.subheading}>{content.processSubheading}</p>
        <div style={styles.grid}>
          {content.steps.map((step, index) => (
            <div key={index} style={styles.card}>
              <span style={styles.badge}>{index + 1}</span>
              <h3 style={styles.cardTitle}>{step.title}</h3>
              <p style={styles.cardText}>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "40px 5%",
    background: HOME_THEME.surfaceAlt,
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center" as const,
    fontSize: "1.9rem",
    fontWeight: 800,
    margin: "0 0 6px 0",
    color: HOME_THEME.heroHeading,
  },
  subheading: {
    textAlign: "center" as const,
    maxWidth: "640px",
    margin: "0 auto 26px",
    color: HOME_THEME.muted,
    lineHeight: 1.5,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
  },
  card: {
    padding: "20px",
    borderRadius: "14px",
    background: HOME_THEME.surface,
    border: `1px solid ${HOME_THEME.border}`,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    background: HOME_THEME.primarySoft,
    color: HOME_THEME.primaryDark,
    fontWeight: 900,
    fontSize: "0.9rem",
    marginBottom: "14px",
  },
  cardTitle: {
    margin: "0 0 8px 0",
    fontSize: "1.1rem",
    fontWeight: 700,
    color: HOME_THEME.heroHeading,
  },
  cardText: {
    margin: 0,
    fontSize: "0.92rem",
    lineHeight: 1.55,
    color: HOME_THEME.muted,
  },
};

export default ProcessSection;
